module.exports = __webpack_public_path__ + "static/media/Waddell-and-Reed.66d095b1.png";